module.exports = __webpack_public_path__ + "img/reload.56619ce8.svg";